<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
        class="bg-gray-900 dark print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div
                class="flex items-center h-20 px-8 pt-6 cursor-pointer"
                (click)="goToHome()"
            >
                <img
                    class="w-24"
                    src="assets/images/logo/logo-text-on-dark.svg"
                    alt="Logo image"
                />
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 bg-[#FFFFFF]">
    <!-- Header -->
    <div
        class="relative flex items-center w-full h-10 px-4 shadow flex-0 sm:h-10 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
        <ng-container *ngIf="!isScreenSmall">
            <!-- Logo -->
            <div
                class="flex items-center mx-2 cursor-pointer lg:mr-8"
                (click)="goToHome()"
            >
                <div class="hidden lg:flex">
                    <img
                        class="w-24 dark:hidden"
                        src="assets/images/logo/logo-text.svg"
                    />
                    <img
                        class="hidden w-24 dark:flex"
                        src="assets/images/logo/logo-text-on-dark.svg"
                    />
                </div>
                <img
                    class="flex w-8 lg:hidden"
                    src="assets/images/logo/logo.svg"
                />
            </div>
            <!-- Horizontal navigation -->
            <fuse-horizontal-navigation
                class="mr-2"
                [name]="'mainNavigation'"
                [navigation]="navigation.horizontal"
            ></fuse-horizontal-navigation>
        </ng-container>
        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </ng-container>
        <!-- Components -->
        <div
            class="flex items-center space-x-0.5 sm:space-x-2"
            [ngClass]="override.isRTL ? 'pr-2 mr-auto' : 'pl-2 ml-auto'"
        >
            <!--language for dashboard-->
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts> -->
            <!-- <messages></messages> -->
            <!-- <notifications></notifications> -->
            <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
            </button> -->
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->

    <div
        class="relative flex items-center w-full h-5 px-4 border-t flex-0 sm:h-5 md:px-6 z-49 bg-card dark:bg-transparent print:hidden"
    >
        <span class="font-medium text-secondary"
            >Shelter Technology &copy; {{ currentYear }}</span
        >
    </div>
</div>
<!--  -->
<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
